export enum ReviewPreset {
  DEFAULT = "",
  MEDICAL_BACKGROUND = "MEDICAL_BACKGROUND",
  DEVICE_SPECIFIC_SEARCH = "DEVICE_SPECIFIC_SEARCH",
  NOTIFIED_BODY = "NOTIFIED_BODY",
  CUSTOM = "CUSTOM",
}
